import { h } from "preact";
import { useState, } from "preact/hooks";

import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Stack, Typography } from "@mui/material";

export default function AcceptBidDialogSeller(props) {

	const [state, setState] = useState({ mode: "step_1" });
	const handleClose = () => {
		props.onClose();
	};

	const handleAccept = () => {
		console.log("handleAccept", props);
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/acceptbid/" + props.state.params.pf.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};

	return (
		<Dialog aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog"><Typography variant="h5" gutterBottom>Accepter une offre d'achat</Typography></DialogTitle>
			<DialogContent dividers>
				{state.mode === "step_1" && <Stack spacing={1}>
					<Typography variant="h5" gutterBottom>
						Voulez-vous accepter l'offre à {props.state.params.pf.p} € ?
					</Typography>
					<Typography variant="body1" gutterBottom>
						Prix net vendeur {props.state.params.pf.pn} €
					</Typography>
					<Typography variant="body1" gutterBottom>
						Horaires Bkeys {props.state.params.pf.c} €
					</Typography>
					<Typography variant="body1" gutterBottom>
						Offre valable jusqu'au {props.state.params.pf.td}
					</Typography>
					{props.state.params.pf.sp && <Typography variant="body1" gutterBottom>
						Sans conditions suspensives
					</Typography>}
					{!props.state.params.pf.sp && <Typography variant="h5" gutterBottom>
						Avec les conditions suspensives suivantes:
					</Typography>}
					{!props.state.params.pf.sp && <Typography variant="body1" gutterBottom>
						Montant emprunté {props.state.params.pf.l} €
					</Typography>}
					{!props.state.params.pf.sp && <Typography variant="body1" gutterBottom>
						Soit un apport personnel de {props.state.params.pf.a} €
					</Typography>}


				</Stack>}
				{state.mode === "step_2" && <Stack>
					<Typography variant="h5" gutterBottom>
						Voulez-vous vraiment accepter cette offre à {props.state.params.pf.p} € ?
					</Typography>

				</Stack>}


			</DialogContent>
			<DialogActions>
				{state.mode === "step_2" && <Box display="flex" justifyContent="space-between" alignItems="center" style="width: 100%">
					<Box>
						<Button variant="contained" onClick={() => setState({ mode: "step_1" })} style="margin: 10px;">
							NON
						</Button>
					</Box>
					<Box>
						<Button variant="contained" onClick={handleAccept} style="margin: 10px;">
							J'ACCEPTE l'offre
						</Button>
					</Box>
				</Box>}
				{state.mode === "step_1" && <Box display="flex" justifyContent="space-between" alignItems="space-between">
					<Box>
						<Button variant="contained" onClick={() => setState({ mode: "step_2" })} style="margin: 10px;">
							OUI
						</Button>
					</Box>
					<Box>
						<Button variant="outlined" onClick={handleClose} style="margin: 10px;">
							Je vais réfléchir
						</Button>
					</Box>
					<Box>
						<Button variant="contained" onClick={() => {
							props.state.params.app.refPopUp.current.handleChangeState(
								{
									opened: true,
									type: "015",
									params: {
										pf: props.state.params.pf,

									}
								}
							)
						}} style="margin: 10px;">
							Je contre-propose
						</Button>
					</Box>
				</Box>}
			</DialogActions>
		</Dialog >
	);
}
